<script lang="ts">
	import { walletConnected, chain, walletLoaded } from '$lib/wallet/store';
	import ProcessingButton from './ProcessingButton.svelte';
	import SwitchToOptimismButton from './SwitchToOptimismButton.svelte';
	import {
		creatingSmartContractWallet,
		tosBeingChecked,
		tosBeingSigned
	} from '$lib/popups/popupsStore';
	import { onboardUser } from './common';
	import { isSupportedNetwork } from './util';
	export let source: string;
</script>

{#if $tosBeingChecked || $tosBeingSigned}
	<ProcessingButton title="Checking Terms & Conditions" />
{:else if $creatingSmartContractWallet}
	<ProcessingButton title="Creating Polynomial Account" />
{:else if $walletLoaded && $walletConnected && !isSupportedNetwork($chain?.id)}
	<SwitchToOptimismButton />
{:else}
	<button
		on:click={() => {
			onboardUser(source);
		}}
		on:keydown={() => {
			onboardUser(source);
		}}
		class="flex justify-center items-center gap-3 text-fx-grey-900 font-semibold text-center rounded-xl squircle-xl bg-fx-gradient-9 py-4 cursor-pointer w-full"
	>
		Start Trading
	</button>
{/if}
